
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import NaleveringenTab from "./tabs/NaleveringenTab";
import IncidentenTab from "./tabs/IncidentenTab";
import KleurenTab from "./tabs/KleurenTab";
import OpmerkingenTab from "./tabs/OpmerkingenTab";
import VoorraadTab from "./tabs/VoorraadTab";
import AfwijkendeOrdersTab from "./tabs/AfwijkendeOrdersTab";
import BreukTransportTab from "./tabs/BreukTransportTab";
import DamageAnalysis from "./DamageAnalysis";
import DamageReport from "./DamageReport";

import {
  orderStatusData,
  monthlyOrdersData,
  incidentsData,
  monthlyIncidents,
  colorsData,
  kleurBeschikbaarheid,
  commentsData,
  commentsProcessingData,
  inventoryData,
  inventoryTrendData,
  deviantOrdersData,
  deviantReasonsData,
  transportDamageData,
  transportDamageTrendData
} from "@/data/reportsData";

const ReportTabContent: React.FC<{ activeTab: string }> = ({ activeTab }) => {
  return (
    <>
      <TabsContent value="naleveringen">
        <NaleveringenTab 
          orderStatusData={orderStatusData} 
          monthlyOrdersData={monthlyOrdersData} 
        />
      </TabsContent>

      <TabsContent value="incidenten">
        <IncidentenTab 
          incidentsData={incidentsData} 
          monthlyIncidents={monthlyIncidents} 
        />
      </TabsContent>

      <TabsContent value="kleuren">
        <KleurenTab 
          colorsData={colorsData} 
          kleurBeschikbaarheid={kleurBeschikbaarheid} 
        />
      </TabsContent>

      <TabsContent value="opmerkingen">
        <OpmerkingenTab 
          commentsData={commentsData} 
          commentsProcessingData={commentsProcessingData} 
        />
      </TabsContent>

      <TabsContent value="voorraad">
        <VoorraadTab 
          inventoryData={inventoryData} 
          inventoryTrendData={inventoryTrendData} 
        />
      </TabsContent>

      <TabsContent value="afwijkende-orders">
        <AfwijkendeOrdersTab 
          deviantOrdersData={deviantOrdersData} 
          deviantReasonsData={deviantReasonsData} 
        />
      </TabsContent>

      <TabsContent value="breuktransport">
        <BreukTransportTab 
          transportDamageData={transportDamageData} 
          transportDamageTrendData={transportDamageTrendData} 
        />
      </TabsContent>

      <TabsContent value="schadeanalyse">
        <DamageAnalysis />
      </TabsContent>

      <TabsContent value="schaderapport">
        <DamageReport />
      </TabsContent>
    </>
  );
};

export default ReportTabContent;
